import DOMPurify from "dompurify";

let configured = false;

function configure() {
  if (configured) return;
  configured = true;

  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
      const existing = node.getAttribute("class") || "";
      if (!existing.includes("text-theme")) {
        node.setAttribute("class", `${existing} text-theme`.trim());
      }
    }
    if (node.tagName === "IMG") {
      node.setAttribute("loading", "lazy");
      const existing = node.getAttribute("class") || "";
      const wanted = "my-2 w-100 rounded-2 mx-auto";
      if (!existing) node.setAttribute("class", wanted);
    }
  });
}

export function sanitizeHTML(content) {
  if (!content) return "";
  configure();
  return DOMPurify.sanitize(content, { USE_PROFILES: { html: true } });
}
